module.exports = __webpack_public_path__ + "static/media/click2.f700dd1d.aac";